<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <template>
                    <h1 class="text-subtitle-1">
                        Proszę wybrać powód przerwy.
                    </h1>
                </template>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-select
                                v-model="comment"
                                :items="commentCodes"
                                item-text="description"
                                outlined
                                no-data-text="Nie znaleziono komentarzy"
                                label="Komentarz"
                                return-object
                                required
                                dense
                                :error-messages="commentCodeErrors"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Potwierdź"
                    :loading="actionLoading "
                    @click="onSave()"
                >
                    Potwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'ReportBreakCommentCodeDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        actionLoading: {
            type: Boolean
        },
        reportData: {
            type: Object,
            default: null
        },
        commentCodes: {
            type: Array,
            default: () => []
        },
        codeTypeId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            report: null,
            comment: null
        }
    },
    validations: {
        comment: {
            required: required
        }
    },
    computed: {
        commentCodeErrors() {
            const errors = []

            if (!this.$v.comment.$dirty) return errors
            !this.$v.comment.required && errors.push('Proszę wybrać przyczynę.')

            return errors
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.report = JSON.parse(JSON.stringify(this.reportData))
            } else {
                this.$v.$reset()
                setTimeout(() => {
                    this.report = {}
                    this.comment = null
                }, 500)
            }
        }
    },
    methods: {
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            if (this.comment.id !== 5) this.report.comments.push({commentCodeId : this.comment.code})

            this.$emit('on-save', {report: this.report, selectedComment: this.comment})
        },
        onClose() {
            this.$emit('on-close')
        },
    }
}
</script>

